// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Milieu Klachten Applicatie',
  api_endpoint: 'https://api.milieuklachtencentrale.nl/',
  latitude: 51.55,
  longitude: 5.083333,
  sentry: 'https://86f8789e3f525d880d340ea34fd4a767@o4507735602298880.ingest.de.sentry.io/4507748306714704',
};
